import { convertHexToRGBA as rgba } from '../../helpers/theme'
import colors from './colors'

export default {
    default: `0px 2px 6px ${rgba(colors.shadow.default, 0.06)}`
}
